namespace app.tarefas.minhasTarefas {
    "use strict";

    import MessagesService = app.support.messaging.MessagesService;
    import INotification = app.notification.INotification;
    import IUser = app.autenticacao.IUser;
    import AuthorizationService = app.support.authorization.AuthorizationService;
    import AlertService = app.support.alert.AlertService;
        
    declare let angular: ng.IAngularStatic;
    declare let moment: any;

    export interface IPagination {
        currentPage: number;
        pageSize: number;
        numberOfPages: number;
        total: number;
    }

    export interface ITaskFilter {
        value: {};
        active: boolean;
    }

    export interface ITaskFilters {
        tags: ITaskFilter;
        completed: ITaskFilter;
        priority: ITaskFilter;
        starred: ITaskFilter;
        assignee: ITaskFilter;
        assigneeGroup: ITaskFilter;
        cancellation: ITaskFilter;
    }

    export enum SearchCondition {
        AND, OR
    }

    export class MinhasTarefasController {

        public pagination: IPagination = <IPagination>{
            currentPage: 0,
            pageSize: 20,
            numberOfPages: 1,
            total: 0
        };

        public taskFilters: ITaskFilters = <ITaskFilters>{
            priority: { value: false, active: false },
            assignee: { value: [], active: true },
            assigneeGroup: { value: [], active: false },
            tags: { value: [], active: true }
        };

        public taskFiltersDefaults: ITaskFilters;
        public taskDateFilter = "startDate";
        public taskOrder: string = "startDate";
        public taskOrderDescending: boolean = true;
        public taskViewExpanded: boolean = false;

        public msScrollOptions: Object = {
            suppressScrollX: true
        };

        public tasks: ITask[];

        public loadingTasks: boolean = false;

        public tags: ITaskTag[] = [];

        public users: string[] = [];
		
		public usersNames:Map = new Map();

        public userLogged: string;

        public filteredTasks: ITask[] = [];

        public exactlySearch = true;

        public searchTask: string;

        public searchCondition: SearchCondition = SearchCondition.AND;

        public fromDateFilter: Date = moment().startOf("d").toDate();

        public minDateFilter: Date;

        public toDateFilter: Date = moment().endOf("d").toDate();

        public maxDateFilter: Date = this.toDateFilter;

        private static get LIMIT_TEXT_EXTRA_INFO() { return 470 };

        private patterns = [{// Processo
            regex: /^([a-zA-Z]+)(\s+)([0-9]{7})$/g,
            replaceFn: (completo: string, sigla: string, espacos: string, numero: string) => {
                return sigla + " " + numero.replace(/^0+/, "");
            }
        }, {// Documento
            regex: /^([0-9]{8})(\-)([0-9]{4})$/g,
            replaceFn: (completo: string, numero: string, traco: string, ano: string) => {
                return numero.replace(/^0+/, "") + traco + ano;
            }
        }, {// Petição
            regex: /^([0-9]{7})([0-9]{4})$/g,
            replaceFn: (completo: string, numero: string, ano: string) => {
                return numero.replace(/^0+/, "") + "/" + ano;
            }
        }];

        /** @ngInject **/
        public constructor(private $document: ng.IDocumentService,
            private $mdDialog: ng.material.IDialogService,
            private $filter: ng.IFilterService,
            private $scope: ng.IScope,
            private $window: ng.IWindowService,
            private $timeout: ng.ITimeoutService,
            private $state: ng.ui.IStateService,
            private messagesService: MessagesService,
            private minhasTarefasService: MinhasTarefasService,
            private tarefasCacheService: TarefasCacheService,
            private rotulosService: RotulosService,            
            user: IUser,
            public userGroups: IGroup[],
            public canPrioritize: boolean,
            public canAnnotate: boolean,
            public canTag: boolean,
            public canRemoveTags: boolean,
            public manualTags: ITaskTag[],
            private alertService: AlertService) {

            this.userLogged = user.login;
            this.taskFilters.assignee.value.push(this.userLogged);
            this.taskFiltersDefaults = angular.copy(this.taskFilters);
            this.tags.push(...manualTags);

            this.tarefasCacheService.registerTaskCallbackFn(() => this.applyTaskFilters());
            this.tarefasCacheService.registerTaskCreatedCallbackFn((task) => this.onTaskCreated(task));
            this.tarefasCacheService.registerTaskAssignedCallbackFn((task) => this.onTaskAssigned(task));
            this.tarefasCacheService.registerTaskTaggedCallbackFn((task) => this.onTaskTagged(task));

            $scope.$on("$destroy", () => this.tarefasCacheService.unregisterCallbacks());

            this.$scope.$on("stf:ui:tag-manual-criada", (event, notificationEvent: INotification) => {
                var tagCriada = notificationEvent.content as ITaskTag;

                // Setando o tipo da tag como o esperado
                tagCriada.type = ITaskTagOrigem[tagCriada.origem] === ITaskTagOrigem.AUTOMATICA ? "Manuais" : tagCriada.type;

                // remapeando as tags de cada tarefa na listagem
                this.updateTagFromName(tagCriada);

                this.refreshTasks();

                this.applyTaskFilters();
            });

            this.$scope.$on("stf:ui:tag-manual-atualizada", (event, notificationEvent: INotification) => {
                var tagAtualizada = notificationEvent.content as ITaskTag;

                // Setando o tipo da tag como o esperado
                tagAtualizada.type = ITaskTagOrigem[tagAtualizada.origem] === ITaskTagOrigem.AUTOMATICA ? "Manuais" : tagAtualizada.type;
    
                this.toggleArrayFilter('tags', tagAtualizada, true);
                this.updateTagFromId(tagAtualizada);
                this.toggleArrayFilter("tags", tagAtualizada, true);

                // remapeando as tags de cada tarefa na listagem
                this.remapTagsOnTasks(tagAtualizada);
                this.refreshTasks();
                this.applyTaskFilters();
            });

            this.$scope.$on("stf:ui:tags-removidas", (event, notificationEvent: INotification) => {
                var tags =  notificationEvent.content as string[];
                tags.forEach(tag => {
                    this.spliceTag(tag, this.tags);
                    this.spliceTag(tag, this.manualTags);
                    this.tasks.forEach(task => this.spliceTag(tag, task.tags));
                });
                this.taskFilters.tags = angular.copy(this.taskFiltersDefaults.tags);
                this.applyTaskFilters();
            });
            
            this.openDialogAlerts();
        }

        private updateTagFromName(tagCriada: ITaskTag): void {
            const _tags = angular.copy(this.tags);
            const _manualTags = angular.copy(this.manualTags);

            // Removendo as tags com o mesmo nome
            _.remove(_tags, t => t.name === tagCriada.name);
            _.remove(_manualTags, t => t.name === tagCriada.name);
            
            // Incluindo a tag criada
            _tags.push(tagCriada);
            _tags.sort((u1, u2) => u1.name.localeCompare(u2.name));

            _manualTags.push(tagCriada);
            _manualTags.sort((u1, u2) => u1.name.localeCompare(u2.name));
            

            this.tags = [];
            this.manualTags = [];

            this.tags = _tags;
            this.manualTags = _manualTags;
        }

        private updateTagFromId(tagAtualizada: ITaskTag): void {
            const tagComMesmoId = (tag: ITaskTag) => {
                let remover = tag.id === tagAtualizada.id;
                if (remover) {
                    // mantendo as tasks que já estavam com a tag
                    tagAtualizada.tasks = tag.tasks;
                }
                return remover;
            };
            
            _.remove(this.tags, tagComMesmoId);
            _.delay(() => {
                this.tags.push(tagAtualizada);
                this.tags.sort((u1, u2) => u1.name.localeCompare(u2.name));
            }, 10);

            _.remove(this.manualTags, tagComMesmoId);
            _.delay(() => {
                this.manualTags.push(tagAtualizada);
                this.manualTags.sort((u1, u2) => u1.name.localeCompare(u2.name));
            }, 10);
        }

        private remapTagsOnTasks(tag: ITaskTag): void {
            const remapTags = (_tags: ITaskTag[]) => {
                return angular.copy(_tags || [])
                    .map(item => item.id === tag.id ? tag : item);
            };

            this.tasks.forEach(task => {
                let _taskTags = remapTags(task.tags);
                task.tags = [];
                _.delay((tags) => task.tags = tags, 10, _taskTags);
            });
        }

        public $onInit(): void {
            this.loadingTasks = true;
            this.tasks = this.tarefasCacheService.get();

            let init = (first: boolean) => {
				this.loadUsersNames(this.tasks);
                this.loadFilters();
                this.initSearchData(first);
                this.loadingTasks = false;
            };

            if (this.tarefasCacheService.isLoaded()) {
                init(false);
            } else {
                this.minhasTarefasService.get()
                    .then(tasks => {
                        this.tarefasCacheService.register(tasks);
                        init(true);
                    });
            }
        }
		
		public getUserName(login: string): any {
	        if (this.usersNames && login && login != "" && this.usersNames.has(login)) {
	            return this.usersNames.get(login);
	        }
	        return login;
		}
		
		private loadUsersNames(tasks: ITask[]): void {
			let usuarios = new Set();		
			tasks.forEach((task) => {
				if (task.assignee && !this.usersNames.has(task.assignee)) usuarios.add(task.assignee);
				if (task.assignor && !this.usersNames.has(task.assignor)) usuarios.add(task.assignor);
				if (task.cancellation && task.cancellation.canceledBy && !this.usersNames.has(task.cancellation.canceledBy)) usuarios.add(task.cancellation.canceledBy);
				if (task.draft && task.draft.modifiedBy && !this.usersNames.has(task.draft.modifiedBy)) usuarios.add(task.draft.modifiedBy);
						
            });
			if (usuarios && usuarios.size > 0) {
				this.minhasTarefasService.getNomesUsuarios(Array.from(usuarios)).then(resultado => {
					for (const [key, value] of Object.entries(resultado)) {
						this.usersNames.set(key,value);
						this.users.sort((u1, u2) => this.getUserName(u1).localeCompare(this.getUserName(u2)));
					}
				});
			}
		}

        private onTaskCreated(task: ITask): void {
			this.loadUsersNames([task]);
            let startDate = new Date(task.startDate);
            let momentStartDate = moment(startDate);

            if (momentStartDate.isAfter(this.maxDateFilter, "day")) {
                this.maxDateFilter = momentStartDate.endOf("d").toDate();
            }
            this.loadTags(task);
            this.applyTaskFilters();
        }

        private onTaskAssigned(task: ITask): void {
            this.loadUsersNames([task]);
			this.loadUser(task);
            this.applyTaskFilters();
        }

        private onTaskTagged(task: ITask): void {
            this.loadUsersNames([task]);
			this.loadTags(task);
            this.applyTaskFilters();
        }

        private loadFilters(): void {
            this.tasks.forEach((task) => {
                this.loadTags(task);
                this.loadUser(task);

                let startDate = moment(task.startDate);

                if (startDate.isBefore(this.minDateFilter)) {
                    this.minDateFilter = startDate.toDate();
                }
            });
            this.fromDateFilter = this.minDateFilter;
        }

        private initSearchData(first: boolean = false): void {
            this.loadSavedSearchData(first);

            this.$scope.$watch(() => this.taskFilters, () => this.watchListener("taskFilters"), true);

            this.$scope.$watchCollection(() => this.pagination, () => this.watchListener("pagination"));

            angular.forEach(["searchTask", "exactlySearch", "searchCondition", "taskOrder",
                "taskOrderDescending", "taskDateFilter", "fromDateFilter",
                "toDateFilter", "taskViewExpanded"], (prop) => {
                    this.$scope.$watch(() => this[prop], () => this.watchListener(prop));
                });
        }

        private watchListener(property: string): void {
            this.applyTaskFilters();
            this.saveSearchData(property, this[property]);
        }

        private saveSearchData(property: string, data: {}): void {
            let ls = this.$window.localStorage;
            let stringData = ls.getItem("searchData");
            let searchData: {};

            if (!!stringData) {
                searchData = angular.fromJson(stringData);
            } else {
                searchData = {};
            }
            searchData[property] = data;
            ls.setItem("searchData", angular.toJson(searchData));
        }

        private loadSavedSearchData(first: boolean = false): void {
            let ls = this.$window.localStorage;
            let stringData = ls.getItem("searchData");

            if (!!stringData) {
                let searchData = angular.fromJson(stringData);

                for (let key in searchData) {
                    if (key === "pagination") {
                        this.pagination.pageSize = searchData.pagination.pageSize;
                        this.pagination.currentPage = searchData.pagination.currentPage;
                    } else if (key === "fromDateFilter" || (key === "toDateFilter" && !first)) {
                        this[key] = moment(searchData[key]).toDate();
                    } else if (key !== "toDateFilter") {
                        this[key] = searchData[key];
                    }
                }
            }
        }

        public refreshTasks(): void {
            this.loadingTasks = true;
            this.tarefasCacheService.clear();
            this.minhasTarefasService.get()
                .then(tasks => {
                    this.tarefasCacheService.register(tasks);
                    this.loadFilters();
                    this.toDateFilter = moment().endOf("d").toDate();
                    this.maxDateFilter = this.toDateFilter;                    
                    this.applyTaskFilters();
                    this.loadingTasks = false;
					this.loadUsersNames(this.tasks);
                });
        }

        public clearFilters(): void {
            this.taskFilters = angular.copy(this.taskFiltersDefaults);
            this.applyTaskFilters();
        }

        public openTask(task: ITask): void {
            this.minhasTarefasService.openTask(task);
        }

        public viewTask(task: ITask): void {
            this.minhasTarefasService.viewTask(task);
        }

        public filterByTaskLabels(task: ITask, searchText: string): boolean {
            if (!searchText || searchText.length < 2) {
                return true;
            }
            if (this.exactlySearch) {
                return this.find(task, searchText);
            } else {
                let filteredText = searchText.split(" ").filter((text) => text !== "");
                let finder = (text: string) => this.find(task, text);

                if (this.searchCondition === SearchCondition.AND) {
                    return _.every(filteredText, finder);
                } else {
                    return _.some(filteredText, finder);
                }
            }
        }

        public filterByTags(task: ITask, tags: ITaskTag[]): boolean {
            if (tags.length === 0) {
                return true;
            } else {
                let groupTags = _.groupBy(tags, "type");

                return _.every(Object.keys(groupTags), (type) => {
                    return _.intersectionBy(task.tags, groupTags[type], "id").length > 0;
                });
            }
        }

        public filterByValues(task: ITask, values: {}[], filter: string): boolean {
            if (values.length === 0) {
                return true;
            } else {
                return _.some(values, (v) => {
                    return (v === "!!") ? !!task[filter] : task[filter] === v;
                });
            }
        }

        public filterByValue(task: ITask, filter: string): boolean {
            if (this.taskFilters[filter].active) {
                return task[filter] === this.taskFilters[filter].value;
            } else {
                return true;
            }
        }

        public filterByDates(task: ITask): boolean {
            if (!this.taskDateFilter) {
                return true;
            }
            return moment(task[this.taskDateFilter]).isBetween(this.fromDateFilter, this.toDateFilter, "day", "[]");
        }

        public applyTaskFilters(): void {
            this.$timeout(() => {
                let tasks = this.tasks
                    .filter((task) => {
                        return this.filterByValue(task, "priority")
                            && this.filterByValues(task, this.taskFilters.assignee.value, "assignee")
                            && this.filterByValues(task, this.taskFilters.assigneeGroup.value, "assigneeGroup")
                            && this.filterByTags(task, this.taskFilters.tags.value)
                            && this.filterByDates(task)
                            && this.filterByTaskLabels(task, this.searchTask);
                    });

                tasks = _.orderBy(
                    tasks,
                    [task => task[this.taskOrder] || ""],
                    [this.taskOrderDescending ? "desc" : "asc"]);
                this.filteredTasks = this.paginationFilter(tasks);
            }, 500);
        }

        public toggleFilter(filter: string, value: string | boolean): void {
            this.taskFilters[filter].active = !this.taskFilters[filter].active;

            if (this.taskFilters[filter].active) {
                this.taskFilters[filter].value = value;
            } else {
                this.taskFilters[filter].value = this.taskFiltersDefaults[filter].value;
            }
        }

        public toggleArrayFilter(filter: string, value: {}, idSearch?: boolean): void {
            if (!this.isArrayFilterExists(filter, value, idSearch)) {
                this.taskFilters[filter].value.push(value);
            } else if (idSearch) {
                _.remove(this.taskFilters[filter].value, v => v["id"] === value["id"]);
            } else {
                _.remove(this.taskFilters[filter].value, v => v === value);
            }
        }

        public isArrayFilterExists(filter: string, value: {}, idSearch?: boolean): boolean {
            if (idSearch) {
                return this.taskFilters[filter].value.findIndex(o => o.id === value['id']) > -1;
            }
            return this.taskFilters[filter].value.indexOf(value) > -1;
        }

        public hasFilteredItems(filter: string, values: [], idSearch?: boolean): boolean {
            for (let item of values) {
                let searchItem = !idSearch && item['id'] ? item['id'] : item;
                let filtered = this.isArrayFilterExists(filter, searchItem, idSearch);
                if (filtered) { return true }
            };
            return false;
        }

        public countTasksWithFilter(filter: {}, comparator: boolean): number {
            return this.$filter("filter")(this.tasks, filter, comparator).length;
        }

        public hasSelectedTasks(): boolean {
            let selecteds = this.filteredTasks.filter(task => task.selected);
            return selecteds.length > 0;
        }

        public hasAssumableSelectedTasks(): boolean {
            let selecteds = this.filteredTasks
                .filter(task => task.selected && !task.readOnly && !task.restricted);
            return selecteds.length > 0;
        }

        public hasCancelableSelectedTasks(): boolean {
            let selecteds = this.filteredTasks
                .filter(task => task.selected && task.cancelable && !task.readOnly && !task.restricted);
            return selecteds.length > 0;
        }

        public unSelect(tasks: ITask[]): void {
            tasks.forEach((task) => task.selected = false);
        }

        public openTaskWithSearchableId(): void {
            let tasks = this.filteredTasks.filter(task => !task.readOnly && !task.restricted);

            if (tasks.length === 1) {
                this.minhasTarefasService.openTask(tasks[0]);
            } else if (tasks.length > 0) {
                this.messagesService.error("Há mais de uma tarefa, por favor selecione qual deseja abrir.");
            } else {
                this.messagesService.error("Nenhuma tarefa encontrada para abrir, por favor faça outra pesquisa.");
            }
        }

        public setPriority(task: ITask): void {
            let cmd = new SetPriorityTaskCommand(task.context, task.id);
            cmd.priority = !task.priority;

            this.minhasTarefasService.setPriority(cmd);
        }

        public setNotes(task: ITask): void {
            if (this.canAnnotate) {
                this.annotateTaskDialog(task);
            }
        }

        public assignTask(task: ITask): void {
            this.assignTasksDialog([task]);
        }

        public assignTasks(): void {
            let tasks: ITask[] = this.filteredTasks
                .filter((task) => task.selected);
            this.assignTasksDialog(tasks);
        }

        public assignGroupTasks(): void {
            let tasks: ITask[] = this.filteredTasks
                .filter((task) => task.selected && !task.restricted);
            this.assignGroupTasksDialog(tasks);
        }

        public assignTagTasks(): void {
            let tasks: ITask[] = this.filteredTasks
                .filter((task) => task.selected);
            this.assignTagTasksDialog(tasks).then(() => {
                this.unSelect(tasks);
            }).catch(() => {
                this.messagesService.error("Não foi possível atribuir rótulo.");
            });
        }

        public unassignTagTasks(): void {
            let tasks: ITask[] = this.filteredTasks
                .filter((task) => task.selected);
            this.unassignTagTasksDialog(tasks).then(() => {
                this.unSelect(tasks);
            }).catch(() => {
                this.messagesService.error("Não foi possível remover atribuição de rótulo.");
            });
        }

        public assumeTasks(): void {
            let selectedTasks = this.filteredTasks
                .filter(task => task.selected);

            if (selectedTasks.length > 0) {
                let tasks = selectedTasks
                    .filter(task => task.assignee !== this.userLogged &&
                                    !task.readOnly && !task.restricted);
                if (tasks.length > 0) {
                    let cmd = new AssumeTasksCommand();
                    cmd.addTasks(tasks);

                    this.minhasTarefasService.assumeTasks(cmd)
                        .then(() => this.unSelect(selectedTasks));
                } else {
                    this.unSelect(selectedTasks);
                }
            }
        }

        public cancelTasks(): void {
            let tasks: ITask[] = this.filteredTasks
                .filter((task) => task.selected && task.cancelable && !task.readOnly);
            this.cancelTasksDialog(tasks);
        }

        public taskTrack(task: ITask): string {
            return task.context + "-" + task.id;
        }

        public openHistoricTasks(): void {
            this.$state.go("app.tarefas.minhas-tarefas.historico");
        }

        public selectAllFilteredTasks(selected: boolean): void {
            this.filteredTasks.forEach((task) => task.selected = selected);
        }

        public isAllFilteredTasksSelected(): boolean {
            let tasks = this.filteredTasks;
            if (tasks.length === 0) { return false; }
            return tasks.length === tasks.filter((task) => task.selected).length;
        }

        public isUserGroup(groupId: number) {
            return this.userGroups.some(g => g.id === groupId);
        }

        public groupName(groupId: number) {
            let group = this.userGroups.find(g => g.id === groupId);
            return group ? group.nomeArvore : "Não pertencente";
        }

        public groupNameParent(group: IGroup) {
            let names = group.nomeArvore.split(" > ");
            names.splice(-1);
            return names.join(" > ");
        }

        private paginationFilter(tasks: ITask[]): ITask[] {
            this.validatePageSize();
            this.pagination.total = tasks.length;
            this.pagination.numberOfPages = Math.ceil(tasks.length / this.pagination.pageSize);

            if (this.pagination.numberOfPages === 0) {
                this.pagination.numberOfPages = 1;
            }
            if (this.pagination.currentPage >= this.pagination.numberOfPages) {
                this.pagination.currentPage = this.pagination.numberOfPages - 1;
            }
            let start = this.pagination.currentPage * this.pagination.pageSize;
            let pageSize = this.pagination.pageSize;

            start = +start;
            pageSize = +pageSize;

            while (start > tasks.length) {
                start -= pageSize;
            }
            if (start < 0) {
                start = 0;
            }
            return tasks.slice(start, start + this.pagination.pageSize);
        }

        private validatePageSize(): void {
            if (!this.pagination.pageSize || this.pagination.pageSize < 1) {
                this.pagination.pageSize = 1;
            } else if (this.pagination.pageSize > 9999) {
                this.pagination.pageSize = 9999;
            }
        }

        public paginationPrevious(): void {
            let page = this.pagination.currentPage - 1;
            if (page >= 0) {
                this.pagination.currentPage = page;
            } else {
                this.pagination.currentPage = 0;
            }
        }

        public paginationNext(): void {
            let page = this.pagination.currentPage + 1;
            if (page >= this.pagination.numberOfPages) {
                this.pagination.currentPage = this.pagination.numberOfPages - 1;
            } else {
                this.pagination.currentPage = page;
            }
        }

        public paginationFirst(): void {
            this.pagination.currentPage = 0;
        }

        public paginationLast(): void {
            this.pagination.currentPage = this.pagination.numberOfPages - 1;
        }

        public formatDate(date: number | string): string {
            return this.$filter("date")(date, "dd/MM/yyyy HH:mm:ss");
        }

        public setTags(task: ITask): ng.IPromise<void> {
            return this.setTaskTagsDialog(task)
                .then(() => {
                    this.loadTags(task);
                });
        }

        public removeTag(task: ITask, tag: ITaskTag): ng.IPromise<void> {
            return this.removeTaskTagsDialog(task, tag)
                .then(() => {
                    this.loadTags(task);
                });
        }

        public createTag(): ng.IPromise<void> {
            return this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: CreateTagController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/create-tag.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true
            }).then((newTag: ITaskTag) => {
                this.rotulosService.create(newTag)
                    .then(tag => {
                        this.$scope.$broadcast("stf:ui:tag-manual-criada", { content: tag });
                        this.messagesService.success("Rótulo criado com sucesso!");
                    })
                    .catch((e) => {
                        const message = JSON.parse(e.data);
                        this.messagesService.error(message.errors[0].userMessage);
                    });
            });
        }

        public removeTags(): ng.IPromise<void> {
            return this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: RemoveTagsController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/remove-tags.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: {
                    tags: this.manualTags
                }
            }).then((tags: string[]) => {
                this.rotulosService.remove(tags)
                    .then((tags: string[]) => {
                        this.$scope.$broadcast("stf:ui:tags-removidas", { content: tags });

                        const plural = tags.length > 1 ? "s" : "";
                        this.messagesService.success(`Rótulo${plural} removido${plural} com sucesso!`);
                    }, () => this.messagesService.error("Erro ao remover rótulos selecionados!"));
            });
        }

        public updateTags(): ng.IPromise<void> {
            return this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: UpdateTagsController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/update-tags.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: {
                    tags: this.manualTags
                }
            }).then((tagAtualizada: ITaskTag) => {
                this.rotulosService.update(tagAtualizada)
                    .then(() => {
                        this.$scope.$broadcast("stf:ui:tag-manual-atualizada", { content: tagAtualizada });
                        this.messagesService.success("Rótulo alterado com sucesso!");
                    }, () => this.messagesService.error("Erro ao alterar rótulo!"));
            });
        }

        private loadCreatedTask(task: ITask, readOnly: boolean): void {
            let startDate = new Date(task.startDate);
            let momentStartDate = moment(startDate);

            task.readOnly = readOnly;
            task.startDate = startDate.toISOString();

            if (momentStartDate.isAfter(this.maxDateFilter, "day")) {
                this.maxDateFilter = momentStartDate.endOf("d").toDate();
            }
            this.tasks.push(task);
            this.loadTags(task);
            this.applyTaskFilters();
        }

        private assignTasksDialog(tasks: ITask[]) {
            let selectedTasks = tasks.filter(task => !task.restricted);
            
            let resources: IResource[] = [];
            for (let task of selectedTasks) {
                resources.push({
                    nome: task.command,
                    contexto: task.context,
                    tipo: "ACAO",
                    somenteLeitura: false
                });
            }

            /** @ts-ignore */
            this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: AssigneeController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/assignee/assignee.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: {
                    tasks: selectedTasks,
                    resources: resources
                },
                resolve: {
                    users: () => {
                        return this.minhasTarefasService.listUsersByResources(resources, true);
                    }
                }
            });
        }

        private assignGroupTasksDialog(tasks: ITask[]) {
            this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: AssigneeGroupController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/assignee-group/assignee-group.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: {
                    tasks: tasks,
                    groups: this.userGroups
                }
            });
        }

        private cancelTasksDialog(tasks: ITask[]) {
            this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: CancellationController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/cancellation/cancellation.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: { tasks: tasks }
            });
        }

        private annotateTaskDialog(task: ITask) {
            this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: AnnotateController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/notes/notes.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: { task: task }
            });
        }

        private setTaskTagsDialog(task: ITask): ng.IPromise<void> {
            return this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: TagsController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/tags.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: {
                    task: task,
                    tags: this.manualTags.filter(t => !_.some(task.etags, id => id === t.id))
                }
            });
        }

        private assignTagTasksDialog(tasks: ITask[]): ng.IPromise<void> {
            return this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: AssignTagController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/assign-tags.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: { tasks: tasks, tags: this.manualTags }
            });
        }

        private unassignTagTasksDialog(tasks: ITask[]): ng.IPromise<void> {
            const selectedTags = this.getTagsFromSelectedTasks(tasks);
            const tags = this.manualTags.filter(t => _.some(selectedTags, id => id === t.id));
            return this.$mdDialog.show(<ng.material.IDialogOptions>{
                controller: UnAssignTagController,
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/tags/unassign-tags.html",
                parent: this.$document.find("body"),
                clickOutsideToClose: true,
                locals: { tasks: tasks, tags: tags }
            }).then((command: UnAssigneeTagTasksCommand) => {
                if(command !== null){
                    this.minhasTarefasService.unsetTagsTasks(command).then(() => {
                        command.tasks.forEach(task => {
                            this.removeTagsTask(task, command.tags);
                        });
                        this.unSelect(tasks);
                        this.messagesService.success("Atribuições de rótulos removidas com sucesso!");
                    });
                }
            });
        }

        public removeTaskTagsDialog(task: ITask, tag: ITaskTag): ng.IPromise<{}> {
            let confirm = this.$mdDialog.confirm()
                .title("Excluir rótulo")
                .textContent(`Deseja excluir o rótulo "${tag.name}" ?`)
                .ariaLabel("Excluir rótulo")
                .ok("Confirmar")
                .cancel("Cancelar");

            return this.$mdDialog.show(confirm)
                .then(() => {
                    let cmd = new RemoveTagTaskCommand(task.context, task.id);
                    cmd.tag = tag.id;
                    return this.minhasTarefasService.removeTag(cmd);
                });
        }

        public sizeMaxAllowed(valor: string): boolean {
            if (valor.length > MinhasTarefasController.LIMIT_TEXT_EXTRA_INFO) {
                return true;
            }
            return false;
        }

        public sliceTextSize(valor: string): string {
            if (valor.length > MinhasTarefasController.LIMIT_TEXT_EXTRA_INFO) {
                let text = valor.slice(0, MinhasTarefasController.LIMIT_TEXT_EXTRA_INFO);
                let lastSpace = text.lastIndexOf(" ");
                return text.slice(0, lastSpace);
            }
            return valor;
        }

        public openDialogExtraInfo(chave: string, valor: string) {
            let dialog = this.$mdDialog.alert()
                .title(this.convertTextToCapitalize(chave))
                .ok("Fechar")
                .textContent(valor);
            return this.$mdDialog.show(dialog);
        }

        private loadUser(task: ITask): void {
            if (task.assignee) {
                if (task.assignee === this.userLogged) {
                    task.selfAssigned = true;
                } else {
                    task.selfAssigned = false;
                    let indexFound = this.users.indexOf(task.assignee);

                    if (indexFound === -1) {
                        this.users.push(task.assignee);
                        this.users.sort((u1, u2) => this.getUserName(u1).localeCompare(this.getUserName(u2)));
                    }
                }
            }
        }

        private loadTags(task: ITask): void {
            this.rotulosService.load(task, this.manualTags)
                .then(() => {
                    if (task.tags) {
                        task.tags.forEach((tag) => {
                            let indexFound = this.tags.findIndex((t) => t.id === tag.id);

                            if (indexFound === -1) {
                                this.tags.push(tag);
                            }
                        });
                    } else {
                        task.tags = [];
                    }
                });
        }

        private find(item: ITask, searchText: string) {
            return this.findBySearchbleId(item, searchText) ||
                this.findByTitle(item, searchText) ||
                this.findByGroupName(item, searchText) ||
                this.findByTagName(item, searchText) ||
                this.findByNotes(item, searchText) ||
                this.findByAssignee(item, searchText) ||
                this.findByStartDate(item, searchText) ||
                this.findByExtraInfo(item, searchText) ||
                this.findByModifiedBy(item, searchText) ||
                this.findByModifiedDate(item, searchText);
        }

        private findBySearchbleId(item: ITask, text: string): boolean {
            if (!!item.searchableId) {
                for (let pattern of this.patterns) {
                    pattern.regex.lastIndex = 0;
                    if (pattern.regex.test(text)) {
                        pattern.regex.lastIndex = 0;
                        text = text.replace(pattern.regex, pattern.replaceFn);
                        return item.searchableId && item.searchableId.toUpperCase() === text.toUpperCase();
                    }
                }
            }
            return false;
        }

        private findByTitle(item: ITask, text: string): boolean {
            if (!!item.title) {
                return _.deburr(item.title.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
            }
            return false;
        }

        private findByAssignee(item: ITask, text: string): boolean {
            if (!!item.assignee) {
                return item.assignee.toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }

        private findByGroupName(item: ITask, text: string): boolean {
            if (!!item.assigneeGroup) {
                return this.groupName(item.assigneeGroup).toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }

        private findByTagName(item: ITask, text: string): boolean {
            if (!!item.tags) {
                return item.tags
                    .filter((tag) => !!tag.name)
                    .some((tag) => _.deburr(tag.name.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1);
            }
            return false;
        }

        private findByNotes(item: ITask, text: string): boolean {
            if (!!item.notes) {
                return item.notes.toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }

        private findByStartDate(item: ITask, text: string): boolean {
            if (!!item.startDate) {
                let data: string = this.formatDate(item.startDate);
                return data.indexOf(text) !== -1;
            }
            return false;
        }

        private findByModifiedDate(item: ITask, text: string): boolean {
            if (!!item.draft && !!item.draft.modifiedDate) {
                let data: string = this.formatDate(item.draft.modifiedDate);
                return data.indexOf(text) !== -1;
            }
            return false;
        }

        private findByModifiedBy(item: ITask, text: string): boolean {
            if (!!item.draft && !!item.draft.modifiedBy) {
                return item.draft.modifiedBy.toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }

        private findByExtraInfo(item: ITask, text: string): boolean {
            if (!!item.extraInfo) {
                for (let key in item.extraInfo) {
                    if (item.extraInfo[key] !== null) {
                        let encontrou = _.deburr(item.extraInfo[key].toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
                        if (encontrou) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        private convertTextToCapitalize(text: string): string {
            return text[0].toUpperCase() + text.substr(1);
        }

        private spliceTag(id: string, tags: ITaskTag[]) {
            let index = tags.findIndex(t => t.id === id);
            if (index > -1) {
                tags.splice(index, 1);
            }
        }

        private removeTagsTask(task: ITask, tags: string[]) {
            this.tasks.forEach(task => {
                tags.forEach(tag => {
                    if (task.etags !== null) {
                        let index = task.etags.findIndex(t => t === tag);
                        if (index > -1) {
                            task.etags.splice(index, 1);
                        }
                    }
                });
            });
        }

        private getTagsFromSelectedTasks(tasks: ITask[]): String[] {
            let tagsSelectedTasks = [];
            tasks.forEach(task => {
                if (task.etags !== null) {
                    task.etags.forEach(tag => {
                        let existsInSelectedTasks = tagsSelectedTasks.findIndex(t => t === tag);
                        if (existsInSelectedTasks === -1) {
                            tagsSelectedTasks.push(tag);
                        }
                    });
                    task.tags.forEach(tag => {
                        if(tag.type === "Manuais"){
                            let existsInSelectedTasks = tagsSelectedTasks.findIndex(t => t === tag.id);
                            if (existsInSelectedTasks === -1) {
                                tagsSelectedTasks.push(tag.id);
                            }
                        }
                    });
                }
            });
            return tagsSelectedTasks;
        }

        private openDialogAlerts(): ng.IPromise<void> {

            return this.alertService.recuperarAlertasNaoLidos()
                .then(alertas => {                    
                    if (alertas.length > 0) {
                        return this.$mdDialog.show(<ng.material.IDialogOptions>{
                                controller: "app.support.alert.AlertController",
                                controllerAs: "vm",
                                templateUrl: "app/main/support/alert/alert-dialog.html",
                                parent: this.$document.find("body"),
                                clickOutsideToClose: true,
                                locals: {
                                    alertas: alertas                                    
                                }
                            });
                    }
                });            
        }
    }

    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.MinhasTarefasController", MinhasTarefasController);
}
